// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as Turbo from "@hotwired/turbo"
import { createConsumer } from "@rails/actioncable"
import "./controllers"

window.App = window.App || {}
window.App.cable = createConsumer()

Turbo.setConfirmMethod((message) => {
  return new Promise((resolve) => {
    const overlay = document.createElement("div")
    overlay.className = "fixed inset-0 z-[9999] flex items-center justify-center modal-backdrop"
    overlay.innerHTML = `
      <div class="bg-surface-1 border border-border-subtle rounded-2xl shadow-xl p-6 max-w-sm w-full mx-4 space-y-4">
        <h3 class="text-base font-semibold text-text-primary">Confirmation</h3>
        <p class="text-sm text-text-secondary">${message}</p>
        <div class="flex items-center gap-3 pt-2">
          <button data-action="cancel" class="btn btn-secondary flex-1 text-sm">Annuler</button>
          <button data-action="confirm" class="btn btn-primary flex-1 text-sm">Confirmer</button>
        </div>
      </div>
    `
    document.body.appendChild(overlay)

    const cleanup = (result) => {
      overlay.remove()
      resolve(result)
    }

    overlay.querySelector("[data-action=cancel]").addEventListener("click", () => cleanup(false))
    overlay.querySelector("[data-action=confirm]").addEventListener("click", () => cleanup(true))
    overlay.addEventListener("click", (e) => { if (e.target === overlay) cleanup(false) })
    document.addEventListener("keydown", function handler(e) {
      if (e.key === "Escape") { cleanup(false); document.removeEventListener("keydown", handler) }
    })
  })
})

// Validation formulaire : surligne les champs obligatoires vides au submit
document.addEventListener("submit", (event) => {
  const form = event.target
  if (form.tagName !== "FORM" || form.noValidate) return
  form.querySelectorAll(".field-invalid").forEach(el => el.classList.remove("field-invalid"))
  if (!form.checkValidity()) {
    form.classList.add("submitted")
    form.querySelectorAll("select:invalid").forEach(select => {
      const comboboxInput = select.closest("[data-controller='combobox']")?.querySelector("input")
      if (comboboxInput) comboboxInput.classList.add("field-invalid")
    })
  }
}, { capture: true })

// Chartkick + Chart.js
import "chartkick/chart.js"

// Toast après navigation Turbo (ex: job async terminé)
import { showToast } from "./helpers/toast"
document.addEventListener("turbo:load", () => {
  const pending = sessionStorage.getItem("pendingToast")
  if (!pending) return
  sessionStorage.removeItem("pendingToast")
  try {
    const { message, type } = JSON.parse(pending)
    showToast(message, type)
  } catch {}
})

// Reset scroll des conteneurs internes apres navigation Turbo
// (Turbo ne gere que window.scrollTop, pas les overflow containers)
document.addEventListener("turbo:before-render", () => {
  const sidebar = document.querySelector(".sidebar-nav")
  if (sidebar) sessionStorage.setItem("sidebarScroll", sidebar.scrollTop)
  document.querySelector(".page-container")?.scrollTo(0, 0)
})

document.addEventListener("turbo:render", () => {
  const sidebar = document.querySelector(".sidebar-nav")
  const saved = sessionStorage.getItem("sidebarScroll")
  if (sidebar && saved) sidebar.scrollTop = parseInt(saved, 10)
})

// Safeguard : apres chaque navigation Turbo, retire overflow-hidden du body.
// Si une modale reellement visible existe, son controller se reconnectera
// juste apres et re-ajoutera la classe. Evite que le body reste lock quand
// un controller disconnect ne s'est pas execute proprement.
document.addEventListener("turbo:load", () => {
  document.body.classList.remove("overflow-hidden")
})
document.addEventListener("turbo:render", () => {
  document.body.classList.remove("overflow-hidden")
})
